import {useSignal} from '@preact/signals-react'
import {useSignals} from '@preact/signals-react/runtime'
import {Button} from 'primereact/button'

const StyledSpeedDial = ({model = [], callBack = () => {}}) => {
    useSignals()
    const visible = useSignal(false)
    return (
        <div className="fixed bottom-0 right-0 mb-4 mr-4">
            <div id="speed-dial" className="flex flex-column align-items-end">
                {model?.length > 0 && (
                    <div
                        className={`${
                            visible.value ? 'flex flex-column ' : 'hidden'
                        }`}>
                        <ul className="list-none flex flex-column align-items-end">
                            {model?.map(item => {
                                return (
                                    <li className="w-max" key={item?.key}>
                                        <div
                                            className="flex align-items-center text-right text-white surface-700 m-2 p-2 border-round-lg cursor-pointer hover:surface-500"
                                            onClick={() => callBack(item.key)}>
                                            {item?.icon}
                                            <h5 className="m-0 font-normal">
                                                {item?.label}
                                            </h5>
                                        </div>
                                    </li>
                                )
                            })}
                        </ul>
                    </div>
                )}
                <Button
                    className="border-circle p-speeddial-button"
                    icon={visible.value ? 'pi pi-times' : 'pi pi-plus'}
                    onClick={() => (visible.value = !visible.value)}
                />
            </div>
        </div>
    )
}

export default StyledSpeedDial
